module.exports = __webpack_public_path__ + "static/media/supportMessagesSent_20_25.e2c3232e.png";